import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
const StyledNotCompatible = styled.div`
@media (max-width: 1023px) {
   position:absolute;
   z-index:10000000000;
   background:rgba(0,0,0,.95);
   width:100vw;
   height:100vh;
   top:0px;
   text-align:center;
   padding:20px;
   box-sizing:border-box;
}
@media (min-width: 1024px) {
    display:none;
}
`
const NotCompatible = ({dispatch}) => {
    return(<StyledNotCompatible>

    <h1>Sorry!</h1>
        <p>This website was not built for mobile devices, please use on a desktop or laptop running the latest version of Chrome.</p>
    </StyledNotCompatible>)
}

export default connect()(NotCompatible)